import React from "react";
import styled from "styled-components";
import { usePilotageRhStore } from "../../../store/usePilotageRhStore";
import { useTip } from "../Tooltip/Tooltip";

/**
 * Affiche une valeur ; si la comparaison "vs précédent" est activée pour la
 * section et qu'un texte de tooltip est fourni, la valeur devient survolable
 * (couleur au hover + tooltip donnant l'ancienne donnée).
 *
 * `tip` : texte du tooltip déjà formaté, ou `null`/`undefined` si aucune
 * donnée précédente n'est disponible (aucun effet au survol dans ce cas).
 */
const DeltaValue = ({ section, tip, children }) => {
    const compareOn = usePilotageRhStore((s) => !!s.compare[section]);
    const bindTip = useTip();

    if (!compareOn || !tip) return <>{children}</>;

    return <Hoverable {...bindTip(tip)}>{children}</Hoverable>;
};

export default DeltaValue;

const Hoverable = styled.span`
    cursor: default;
    transition: color 0.1s;
    &:hover {
        color: var(--prh-violet-dark);
    }
`;
